import Vue from 'vue'
import Modal from './components/modal'
import RequestInviteModal from './components/request-invite'
import LoginModal from './components/login'
import ContactUs from './components/contact-us'
import Video from './components/video'
import { CardsSlider } from './cards-slider'
import Utils from './utils'

require('../stylesheets/site.less');
require('./modal-scroll-fix');
require('./common');

let vm = new Vue({
    components: {
        'modal': Modal,
        'request-invite-modal': RequestInviteModal,
        'login-modal': LoginModal,
        'contact-us': ContactUs,
        'video-modal': Video
    },

    el: '#app',
    data: {
        currentModal: null,
        modalOpen: false,
        menuOpen: false,
        modalOptions: null,
        cariClubConnectVideoUrl: 'https://www.youtube.com/embed/ylt9K1ywcSY?autoplay=1',
        currentYear: new Date().getFullYear()
    },
    methods: {
        showModal: function (modalName, modalOptions) {
            this['currentModal'] = modalName;
            this['modalOpen'] = true;
            this['modalOptions'] = modalOptions;
        },
    },
    watch: {
        modalOpen: function (newVal) {
            let className = 'modal-open';
            if (newVal) {
                this['menuOpen'] = false;
                document.body.classList.add(className);
            } else {
                document.body.classList.remove(className);
            }
        },

        menuOpen: function (newVal) {
            let className = 'menu-open';
            if (newVal) {
                document.body.classList.add(className);
            } else {
                document.body.classList.remove(className);
            }
        }
    }
});

let sliderElement = <HTMLElement>document.querySelectorAll('[cards-slider]')[0];
if (Utils.getPathName() === '/join') {
    vm['showModal']('request-invite-modal');
}

if (sliderElement) {
    new CardsSlider(sliderElement);
}

if (Utils.getQueryParameterByName('showVideo')) {
    vm['showModal']('video-modal', {url: vm['cariClubConnectVideoUrl']});
}

if (Utils.getQueryParameterByName('returnUrl')) {
    vm['showModal']('login-modal');
}

if (Utils.getQueryParameterByName('showIntroVideo')) {
    vm['showModal']('video-modal');
}

//temp solution to fix production issue with login until we switch to new platform
document.cookie = 'charityroot=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';


// WEBPACK FOOTER //
// ./static-content/public/javascripts/public.ts